import type {
  MeetingFollowExceptionItem,
  MeetingFollowPreferencesResponse,
} from '@wundo/shared/meetingFollow.ts';
import { apiFetch, apiFetchJson } from '@wundo/client/api.ts';

export type { MeetingFollowExceptionItem, MeetingFollowPreferencesResponse };

/** The four flags the choice is made of, without the read-only `configured`. */
export type MeetingFollowPreferences = Omit<
  MeetingFollowPreferencesResponse,
  'configured'
>;

/** What a new exception points at, and what it says. */
export type NewMeetingFollowException = {
  follow: boolean | null;
  record: boolean | null;
} & (
  | { target_kind: 'person'; email: string }
  | { target_kind: 'series'; meeting_id: string }
);

export async function fetchFollowPreferences(): Promise<MeetingFollowPreferencesResponse> {
  return apiFetchJson<MeetingFollowPreferencesResponse>('/meeting-follow-preferences');
}

export async function saveFollowPreferences(
  preferences: MeetingFollowPreferences,
): Promise<MeetingFollowPreferencesResponse> {
  return apiFetchJson<MeetingFollowPreferencesResponse>('/meeting-follow-preferences', {
    method: 'PUT',
    body: JSON.stringify(preferences),
  });
}

export async function fetchFollowExceptions(): Promise<MeetingFollowExceptionItem[]> {
  const { data } = await apiFetchJson<{ data: MeetingFollowExceptionItem[] }>(
    '/meeting-follow-exceptions',
  );
  return data;
}

export async function addFollowException(
  exception: NewMeetingFollowException,
): Promise<MeetingFollowExceptionItem> {
  return apiFetchJson<MeetingFollowExceptionItem>('/meeting-follow-exceptions', {
    method: 'POST',
    body: JSON.stringify(exception),
  });
}

export async function removeFollowException(id: string): Promise<void> {
  await apiFetch(`/meeting-follow-exceptions/${id}`, { method: 'DELETE' });
}
